import { useContext, useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../Context/globalContext";
import FirebaseApp from "../firebase";
import { onValue, ref } from "firebase/database";
import moment from "moment";

export const DeviceSessions = () => {

    const globalContext = useContext(GlobalContext);
    const navigate = useNavigate();
    const { device_id, company_key } = useParams();
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchDeviceSessions();
    }, [])

    const fetchDeviceSessions = () => {
        globalContext.setLoader(true);
        FirebaseApp().then(db => {
            const dbRef = ref(db, `UsedCompanyKeys/${company_key}/${device_id}/timestamp`);
            return onValue(dbRef, (snapshot) => {
                const records = []
                snapshot.forEach(childSnapshot => {
                    records.push({ "timestamp": childSnapshot.key, "session": childSnapshot.val() });
                })
                setData(records);
                globalContext.setLoader(false);
            }, (err) => {
                console.log('error --->', err);
                globalContext.setLoader(false);
            });
        }).catch(err => {
            console.log('error --->', err);
            globalContext.setLoader(false);
        })
    }

    const exportToCSV = () => {
        const csvHeader = 'Session,Timestamp\n';
        const csvData = data.map(d => `${d.session},${moment(Number(d.timestamp)).format('DD-MM-YYYY hh:mm A')}`).join('\n');
        const csvContent = csvHeader + csvData;
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${device_id}_sessions.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <div className="back-button-container">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        ← Back
                    </button>
                </div>
                <div className="session-header">
                    <h1><span className="text-orange">{device_id}</span> Sessions</h1>
                    <Button className="export-button" onClick={exportToCSV}>
                        Export to CSV
                    </Button>
                </div>
            </div>
            <section className="section dashboard">
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Session</th>
                            <th>Timestamp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ?
                            data.map((d) =>
                                <tr key={d.timestamp}>
                                    <td>{d.session}</td>
                                    <td>{moment(Number(d.timestamp)).format('DD-MM-YYYY hh:mm A')}</td>
                                </tr>
                            ) :
                            <tr>
                                <td colSpan={5}>
                                    <h5 className="text-center">No data</h5>
                                </td>
                            </tr>

                        }
                    </tbody>
                </Table>
            </section>
        </main >
    )
}